import { useEffect, useState } from 'react';
import Lookup from 'src/componentes/select-async';
import CausaRiscoEdit from '../paginas/gestao-risco/causas/edit';
import CausaRiscoList from '../paginas/gestao-risco/causas';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

const CausaRisco = (props) => {
  const endpoint = '/CausaRiscoLookup';
  const [podeEditar, setPodeEditar] = useState(false);

  const ObterPermissao = async () => {
    try {
      const response = await http.get(`${endpoint}/ObterPermissaoEditar`);
      setPodeEditar(response?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    ObterPermissao();
  }, []);

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url={endpoint}
      showSearch
      searchComponent={CausaRiscoList}
      editComponent={podeEditar ? CausaRiscoEdit : null}
      clearable={true}
      useClickToOpen={false}
      {...props}
    />
  );
};

export default CausaRisco;
